
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("lAHXi", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-GB.ba7d6ab6.js.map
